<ion-content class="content-theme-one">
  <!--top bar-->
  <div class="sectionContainer" [ngClass]="{'homersAdjustments': homersLayout }">

    <div>
      <!-- back button-->
      <ion-icon style="cursor: pointer;" class="iconOpacity" [ngClass]="{'iconResize': homersLayout, 'iconHomersColor': homersLayout }" size="medium" slot="start" [ios]="'chevron-back-outline'" [md]="'chevron-back-outline'" (click)="closePopup()"></ion-icon>
    </div>
    <div [ngClass]="{'titleText': homersLayout, 'paytoneFont': homersLayout }">
      <!-- title -->
      {{ blog.title.translations[translationService.getLanguage()] }}
    </div>

    <div [ngStyle]="{'width': !(this.authservice.isAuthenticated && this.blog.canBeDeletedByUser) ? '26px' : 'auto'}">
      @if(this.authservice.isAuthenticated && this.blog.canBeDeletedByUser) {
        <!-- delete icon -->
        <ion-icon style="cursor: pointer;" class="iconOpacity" [ngClass]="{'iconResize': homersLayout, 'iconHomersColor': homersLayout }" size="medium" slot="start" [ios]="'trash-outline'" [md]="'trash-sharp'" (click)="deleteblogs()"></ion-icon>
      }
    </div> 

    
  </div>

  <!-- main content -->
  <div class="messagesDisplayer">

    <div class="message">
      <div class="message_img">
        <img class="imgs" [src]="getblogsImage()">
      </div>
      <div class="message_content">
        <div class="message_content_title" [ngClass]="{'paytoneFont': homersLayout, 'homersResize': homersLayout}" [innerHtml]="textDisplay(blog.title, translationService.getLanguage())">
          <!--{{ blog.title.translations[translationService.getLanguage()] }}-->
        </div>

        <div class="message_content_description" [innerHtml]="textDisplay(blog.shortDescription, translationService.getLanguage())">
          <!--{{ blog.longDescription.translations[translationService.getLanguage()] }}-->
        </div>

        <div class="message_content_description" [ngClass]="{'poppinsNormalFont': homersLayout, 'homersDescriptionModif': homersLayout}" [innerHtml]="textDisplay(blog.longDescription, translationService.getLanguage())">
          <!--{{ blog.longDescription.translations[translationService.getLanguage()] }}-->
        </div>

        <!---->
        @if(blog.promotionalCode || (blog.pricingReference?.showPricing && blog.pricingReference?.price)) {
          <div class="Promo_And_Cost_Container">
            
            <div class="Promo_Container" [ngClass]="{'paytoneFont': homersLayout, 'Apply_Font_Weigth': !homersLayout}">
              @if(blog.promotionalCode) {
                {{ 'NewsBlog.PromoCode' | translate }} {{ blog.promotionalCode }}
              }
            </div>

            <div class="Cost_Container" [ngClass]="{'paytoneFont': homersLayout, 'Apply_Font_Weigth': !homersLayout}">
              @if(blog.pricingReference?.showPricing) {
                {{blog.pricingReference?.price | currency}}
              }
            </div>
          </div>
        }

        @if(blog.btnLink?.translations[translationService.getLanguage()] && blog.btnText?.translations[translationService.getLanguage()]) {
          <div class="message_content_options">
            <a class="message_content_options_button" [href]="blog.btnLink?.translations[translationService.getLanguage()]">{{ blog.btnText?.translations[translationService.getLanguage()] }}</a>
          </div>
        }

        <!---->
        @if((blog.noExpiration && blog.expirationDate) || this.availableHoursString) {
          <div class="Expiration_And_TimeRange">
            <div class="Expiration">
              @if(blog.noExpiration && blog.expirationDate) {
                {{'NewsBlog.ExpiresOn' | translate}} {{ formatDate(blog.expirationDate) }}
              }
            </div>
            <div class="TimeRange">
              @if(this.availableHoursString){
                {{'NewsBlog.Applicable' | translate}}{{ this.availableHoursString }}
              }
            </div>
          </div>
        }

        <div class="message_content_disclaimer" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHtml]="textDisplay(blog.disclaimer, translationService.getLanguage())">
          <!--{{ blog.disclaimer.translations[translationService.getLanguage()] }}-->
        </div>

        @if(blog.modalityLink?.translations[translationService.getLanguage()]) {
          <a [href]="blog.modalityLink.translations[translationService.getLanguage()]" class="message_content_modality" [ngClass]="{'poppinsNormalFont': homersLayout}" [innerHtml]="textDisplay(blog.modalityLink, translationService.getLanguage())">
            <!--{{ blog.modalityLink.translations[translationService.getLanguage()] }}-->
          </a>
        }

        
        
      </div>
    </div>
  </div>

  @if(mobile && settings.configuration.uIoptions?.unDockNavigationBar) {
    <app-undocked-navigation-bar style="z-index: 10;"></app-undocked-navigation-bar>
  }

</ion-content>
